module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldIt.1a0f43a2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BoldIt.eot
// module id = 91
// module chunks = 3